import { TimelineEvent } from "@billingnow/zod-schema";
import { apiClient } from "./client";

/**
 * Get timeline events for a relation
 */
export const getRelationTimeline = async (relationId: string): Promise<{ timeline: TimelineEvent[] }> => {
  const response = await apiClient.get<{ timeline: TimelineEvent[] }>("/api/timeline", {
    params: { relationId },
  });
  return response.data;
};
